import {LieuParam} from "@domain/common/lieu/lieu-param";
import {LegacyFloatLabelType as FloatLabelType} from "@angular/material/legacy-form-field";
import {Adresse} from "@domain/profil/adresse";
import {environment} from "@environments/environment";

/**
 * Paramétrage pour la partie tournée du lieu
 */
export class LieuParamTournee extends LieuParam {
    /** {@inheritDoc} */
    urlAdresse = `/controller/Adresse/searchAdresse`;

    /** {@inheritDoc} */
    isSaisieAutorisee = () => true;

    /** {@inheritDoc} */
    isShowAdresseBaseAndEtablissement = true;

    /** {@inheritDoc} */
    titleAdresseTab = 'lieu.tabs.mesAdresses';

    /** {@inheritDoc} */
    libelleInputFormatOnInit = (data: Adresse) => {
        //Si on a pas de libelle
        if (data.libelle == null || data.libelle == '') {
            //On formate l'adresse
            return `${data.rue ? data.rue + ', ' : ''} ${data.codePostal ? data.codePostal + ' ' : ''} ${data.ville}, ${data.pays}`;
        }

        return data.libelle;
    }
    /** {@inheritDoc} */
    floatLabel: FloatLabelType = "always";

    /** {@inheritDoc} */
    isBoutonValider = false;

    /** {@inheritDoc} */
    isGeolocaliserWithoutRue = true;

    /** {@inheritDoc} */
    isGeolocaliserOnSelect = true;

    /** {@inheritDoc} */
    libelleInputFormatOnSelect = (data: { adresse: string }) => data.adresse;

    /** {@inheritDoc} */
    mapper = (data: any) => {
        //On récupère l'objet
        const loc = data.objet;

        return {
            codePays: loc.codePays3,
            codePostal: loc.codePostal,
            id: loc.idLocalisation,
            idAdress: loc.idLocalisation,
            latitude: loc.latitude ?? loc.adresse?.latitude,
            longitude: loc.longitude ?? loc.adresse?.longitude,
            libelleEtablissement: loc.libelleEtablissement,
            rue: loc.rue,
            ville: loc.ville,
            pays: loc.pays,
            adresse: `${loc.rue ? loc.rue + ', ' : ''} ${loc.codePostal ? loc.codePostal + ' ' : ''} ${loc.ville}, ${loc.pays}`
        };
    }

    /** {@inheritDoc} */
    isShowLieuxRecents = true;

    /**
     * Constructeur
     *
     * @param idObject Id de la NDF
     * @param idUser Id du propriétaire de la NDF
     * */
    constructor(idObject: number, idUser: number) {
        super();

        this.urlAdresse = `${environment.baseUrl}/controller/NDF/${idObject}/getListeLieux`;

        //URL pour charger les lieux récents de l'utilisateur
        this.urlLieuxRecents = `${environment.baseUrl}/controller/Adresse/${idUser}/getLieuxRecents`;

        this.idUser = idUser;
    }
}